export function capitalize(text) {
    if (!text) return "";
    return text.charAt(0).toUpperCase() + text.slice(1);
}

// Capitaliza solo lo que está entero en minúsculas; un texto con al menos
// una mayúscula se respeta tal cual (una sigla, un nombre propio o la grafía
// que eligió el analista). Pensado para tipos y valores de categoría, que
// hasta 2026-10 se guardaban siempre en minúsculas.
export function smartCapitalize(text) {
    if (!text) return "";
    if (text !== text.toLowerCase()) return text;
    return capitalize(text);
}
